export default __webpack_public_path__ + "expeditor-arrow.svg";